import React, { useState } from 'react';
import Me from '../assets/images/me.jpg';
import {
  FaChevronDown,
  FaChevronUp,
  FaLinkedin,
  FaPhone,
} from 'react-icons/fa6';
import { FaGithub } from 'react-icons/fa6';
import { FaInstagram } from 'react-icons/fa6';
import { FaFacebookF } from 'react-icons/fa6';
import { FaEnvelope } from 'react-icons/fa6';
import { FaLocationDot } from 'react-icons/fa6';
import { BsArrowBarRight, BsArrowDownShort } from 'react-icons/bs';
import { Link } from 'react-router-dom';

function Profilecard() {
  const [detailsVisible, setDetailsVisible] = useState(false);

  const user_data = {
    image: Me,
    name: 'Muhammad Ali',
    headline: 'Software Engineer',
    email: 'alijutt030627@gmail.com',
    phone: '+92 3062767542',
    location: 'karachi, Pakistan',
    linkedin: 'https://www.linkedin.com/in/muhammadaliashraf01/',
    github: 'https://github.com/MuhammadAliashraf',
    instagram: 'https://www.instagram.com/dev_muhammadali/',
    facebook: 'https://www.facebook.com/profile.php?id=100074050631928',
    resume_url: '',
  };

  const handlenavigateurl = (link) => {
    if (!link.startsWith('http://') && !link.startsWith('https://')) {
      link = 'https://' + link;
    }
    window.location.href = link;
  };
  return (
    <>
      <div className="flex md:block">
        <div class="w-[30%] md:w-fit relative mt-4 mx-4 overflow-hidden rounded-xl bg-white bg-clip-border text-gray-700 shadow-lg">
          <img height="100%" width="100%" src={user_data.image} alt="Me" />
        </div>
        <div class="p-4 text-center">
          <h4 class=" block font-sans text-2xl font-semibold leading-snug tracking-normal text-lightgrey antialiased">
            {user_data.name}
          </h4>
          <Link
            to="https://portfolio-457fb.web.app/admin/portfolio"
            class="text-seagreen font-medium cursor-default"
          >
            {user_data.headline}
          </Link>
        </div>
      </div>
      <div className="flex items-center justify-end h-6 mb-3 mx-4 md:hidden">
        {detailsVisible ? (
          <>
            <FaChevronUp
              className="bg-seagreen text-2xl text-secondary rounded-full p-1 m-2 cursor-pointer"
              onClick={() => setDetailsVisible(!detailsVisible)}
            />
          </>
        ) : (
          <>
            <p className="text-seagreen">More</p>
            <FaChevronDown
              className="bg-seagreen text-2xl text-secondary rounded-full p-1 m-2 cursor-pointer"
              onClick={() => setDetailsVisible(!detailsVisible)}
            />
          </>
        )}
      </div>
      <div
        className={`md:flex flex-col ${detailsVisible ? 'flex' : 'hidden'} `}
      >
        <div class="relative flex flex-col rounded border border-darkgrey px-2 mx-4 mb-4 overflow-clip">
          <div class="flex ">
            <div class="ml-[8px] flex h-[60px] w-auto flex-row items-center">
              <div class="rounded-full p-3 text-seagreen">
                <FaEnvelope class="size-6" />
              </div>
            </div>
            <div class="ml-2 w-auto flex flex-col justify-center flex-wrap">
              <p class=" text-md font-medium text-darkgrey">Email</p>
              <h4 class="text-sm font-bold text-lightgrey">
                {user_data.email}
              </h4>
            </div>
          </div>

          <div class="flex ">
            <div class="ml-[8px] flex h-[60px] w-auto flex-row items-center">
              <div class="rounded-full p-3 text-seagreen">
                <FaPhone class="size-6" />
              </div>
            </div>
            <div class="h-50 ml-2 flex w-auto flex-col justify-center">
              <p class="`text-md font-medium text-darkgrey">Phone</p>
              <h4 class="text-sm font-bold text-lightgrey">
                {user_data.phone}
              </h4>
            </div>
          </div>

          <div class="flex ">
            <div class="ml-[8px] flex h-[60px] w-auto flex-row items-center">
              <div class="rounded-full p-3 text-seagreen">
                <FaLocationDot class="size-6" />
              </div>
            </div>
            <div class="h-50 ml-2 flex w-auto flex-col justify-center">
              <p class="`text-md font-medium text-darkgrey">Location</p>
              <h4 class="text-sm font-bold text-lightgrey">
                {user_data.location}
              </h4>
            </div>
          </div>
        </div>

        <div className="flex flex-wrap justify-center gap-5 p-6 pt-2">
          <button
            className="text-seagreen drop-shadow-[0_0_8px_#2e8b57]"
            onClick={() => handlenavigateurl(user_data.linkedin)}
          >
            <FaLinkedin className="size-6" />
          </button>

          <button
            className="text-seagreen drop-shadow-[0_0_8px_#2e8b57]"
            onClick={() => handlenavigateurl(user_data.github)}
          >
            <FaGithub className="size-6" />
          </button>

          <button
            className="text-seagreen drop-shadow-[0_0_8px_#2e8b57]"
            onClick={() => handlenavigateurl(user_data.instagram)}
          >
            <FaInstagram className="size-6" />
          </button>

          <button
            className="text-seagreen drop-shadow-[0_0_8px_#2e8b57]"
            onClick={() => handlenavigateurl(user_data.facebook)}
          >
            <FaFacebookF className="size-6" />
          </button>
        </div>


        {/* <button
          class="relative flex justify-center p-2 font-bold text-darkgrey items-center mb-4 mx-4 rounded border hover:bg-seagreen hover:border-seagreen"
          onClick={() => handlenavigateurl(user_data.resume_url)}
        >
          Download CV
        </button> */}
      </div>
    </>
  );
}

export default Profilecard;
